/**
 * Was in `tenant_members.email` steht — die eine Stelle für diese Frage.
 *
 * Die Spalte trägt seit S1.6 zweierlei: eine E-Mail-Adresse **oder** einen
 * reinen Benutzernamen. Der Onboarding-Wizard erfasst je Benutzer nur
 * Benutzername und Rolle (`BenutzerTeamsForm.tsx`), die Provisionierung legt
 * beides in derselben Spalte ab. Fast jede Stelle, die mit einer Anmeldung zu
 * tun hat, muss die beiden auseinanderhalten:
 *
 *  - `server/routes/auth.js` — ohne „@" ist es ein Benutzername, und dann ist
 *    die Mandantenkennung Pflicht (Benutzernamen sind nur je Mandant eindeutig).
 *  - `server/passwordSetup.js` — an einen Benutzernamen geht keine Einladung.
 *  - `server/routes/masterdata.js`, `server/routes/tenants.js` — dasselbe für
 *    die Einzel- und die Sammel-Einladung.
 *  - `server/tenancy.js` — „eine Adresse, ein Konto" (S1.5) gilt nur für echte
 *    Adressen; zwei Mandanten dürfen beide einen „chef" führen.
 *  - `src/routes/LoginPage.tsx` — ob das Feld „Mandantenkennung" erscheint.
 *
 * Bis zum Gatter G4 stand die Regel an sechs Stellen ausgeschrieben, in zwei
 * verschiedenen Schärfegraden. Sie **muss** die laxe Fassung bleiben: der
 * partielle Unique-Index `tenant_members_email_global_unique_idx`
 * (server/migrations.js) grenzt mit `position('@' in email) > 0` ab, und ein
 * strengeres Prädikat im Code liefe still gegen einen Index, der andere Zeilen
 * meint. Wer die Regel ändert, ändert also beides zusammen — oder gar nichts.
 *
 * Die strengere Formatprüfung für *eingegebene* Adressen ist eine andere Frage
 * und lebt als `assertEmailFormat` in server/requestValues.js.
 */
export function istAnmeldeAdresse(wert) {
  return typeof wert === "string" && wert.includes("@");
}
